module.exports = __webpack_public_path__ + "5dc1bc158118985ba7c14872e68fb668.svg";